@for (img of images; track $index) {
<div class="card" [style.--i]="$index">
  <img [src]="img" alt="card image" />
</div>
}
